import { DEMO_SKILLS } from '@/data/pulseDemo/demoSkills'
import { DEMO_TEMPLATES } from '@/data/pulseDemo/demoTemplates'

const fromTemplate = (template) => ({
  id: template.id,
  title: template.title,
  description: template.description,
  apps: template.apps,
  usedCount: 0,
  lastUsedMinutesAgo: null,
  instructions: template.skill.instructions,
  examples: template.skill.examples,
})

/** Skills added from Discover (newest first), then the samples, minus deleted. */
export function buildDemoSkills({ overrides, addedSkillIds }) {
  const added = addedSkillIds
    .map((id) => DEMO_TEMPLATES.find((template) => template.id === id && template.skill))
    .filter(Boolean)
    .map(fromTemplate)
  return [...added, ...DEMO_SKILLS].filter((skill) => !overrides[skill.id]?.deleted)
}
